import { useQuery } from '@tanstack/react-query'
import { useUI } from '@/store/ui'
import { Badge, Card } from '@diwata/ironvale'

interface Familiar { id: string; name: string; tier: string; status: string }

type FamiliarTier = 'sovereign' | 'adept' | 'guild'

function tierVariant(tier: string): FamiliarTier {
  if (tier === 'sovereign' || tier === 'adept' || tier === 'guild') return tier
  return 'guild'
}

function statusVariant(status: string) {
  if (status === 'active') return 'success'
  if (status === 'suspended') return 'error'
  return 'neutral'
}

export function ConclavePanel() {
  const { conclaveUrl } = useUI()

  const { data: familiars = [], isLoading } = useQuery({
    queryKey: ['apex-familiars'],
    queryFn: async (): Promise<Familiar[]> => {
      const res = await fetch(`${conclaveUrl}/familiars`, { credentials: 'include' })
      if (!res.ok) throw new Error(`${res.status}`)
      return res.json()
    },
  })

  return (
    <div>
      <div className="ap-page-header">
        <div>
          <div className="ap-page-title">Conclave</div>
          <div className="ap-page-subtitle">Familiar registry overview</div>
        </div>
        <a className="iv-button iv-button--ghost iv-button--sm" href="http://localhost:3001" target="_blank" rel="noreferrer">
          Open Conclave platform ↗
        </a>
      </div>

      {isLoading && <p className="ap-empty">Loading…</p>}

      {!isLoading && familiars.length === 0 && (
        <Card>
          <p style={{ fontSize: 13, color: 'var(--ae-color-text-muted)' }}>No familiars found. Create one in the Conclave platform.</p>
        </Card>
      )}

      {familiars.length > 0 && (
        <div className="ap-grid">
          {familiars.map((f) => (
            <Card key={f.id}>
              <div style={{ fontWeight: 600, marginBottom: 8 }}>{f.name}</div>
              <div style={{ display: 'flex', gap: 6 }}>
                <Badge variant={tierVariant(f.tier)} style={{ textTransform: 'capitalize' }}>{f.tier}</Badge>
                <Badge variant={statusVariant(f.status)} style={{ textTransform: 'capitalize' }}>{f.status}</Badge>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  )
}
